import InfoIcon from '@mui/icons-material/Info';
import InfoTwoToneIcon from '@mui/icons-material/InfoTwoTone';
import { Button as MuiButton } from '@mui/material';
import {
  GridColDef,
  GridRowId,
  GridRowParams,
  GridSelectionModel,
} from '@mui/x-data-grid';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { Checkbox, Table, TableText } from '../../../components';
import {
  useDispatch,
  useSelector,
  fetchNotificationInfo,
  fetchNotificationsList,
  notificationSlice,
  notificationsListSlice,
} from '../../../stores';
import { handleMoney } from '../../../utils/Helpers';
import useResponsiveMode from '../../../utils/useResponsiveMode';
import { NotificationsIssuedTableToolbar } from './NotificationsIssuedTableToolbar';

export const NotificationsIssuedTable = (props: {
  selectedRows: GridSelectionModel;
  setSelectedRows: Dispatch<SetStateAction<GridSelectionModel>>;
  plate?: string;
}) => {
  const dispatch = useDispatch();
  const {
    notificationsList,
    notificationsListLoading,
    notificationsTotalsSum,
  } = useSelector((state) => state.notificationsListReducer);
  const notificationsFiltersValues = useSelector(
    (state) => state.notificationsFiltersValuesReducer,
  );
  const { notificationsPage } = useSelector(
    (state) => state.notificationsListReducer,
  );
  const responsiveMode = useResponsiveMode();
  const [rows, setRows] = useState<any[]>([]);

  const {
    startDateTime,
    finalDateTime,
    plate,
    notificationId,
    notificationUserId,
    paymentOriginId,
    situationId,
    routeAreaId,
    routeId,
    userName,
    serviceOrderOrigin,
    print,
  } = notificationsFiltersValues;

  const handlePrice = (value: string, situation: string) => {
    if (value && situation) {
      if (situation == 'Paga' || situation == 'Irregular') {
        if (+value > 0) {
          return handleMoney(value);
        }
      }
    }
    return '-';
  };

  useEffect(() => {
    if (notificationsList && notificationsList !== undefined) {
      setRows(notificationsList.page);
    } else setRows([]);
  }, [notificationsList]);

  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Identificador',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => <TableText label={params.row.id} />,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'vehicle',
      headerName: 'Veículo',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => <TableText label={params.row.vehicle} />,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'registrationDateTime',
      headerName: 'Data de criação',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <TableText label={params.row.registrationDateTime} />
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'userLogin',
      headerName: 'Usuário',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => <TableText label={params.row.userLogin} />,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'situation',
      headerName: 'Situação',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => <TableText label={params.row.situation} />,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'value',
      headerName: 'Preço',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <TableText
          label={handlePrice(params.row.value, params.row.situation)}
        />
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'routeName',
      headerName: 'Trecho',
      editable: false,
      sortable: false,
      flex: 2,
      renderCell: (params) => (
        <TableText label={params.row.routeName} size={75} />
      ),
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'actions',
      headerName: 'Ações',
      editable: false,
      sortable: false,
      // flex: 1,
      renderCell: (params) => {
        return responsiveMode === 'large-screen' ? (
          <MuiButton
            variant='contained'
            startIcon={<InfoIcon />}
            size='small'
            onClick={() => handleInfo(params.id, params.row.situation)}
            sx={{ paddingLeft: 1, paddingRight: 1, fontSize: '10px' }}
          >
            Detalhar
          </MuiButton>
        ) : (
          <MuiButton
            variant='contained'
            size='small'
            onClick={() => handleInfo(params.id, params.row.situation)}
          // sx={{
          //   minWidth: 0,
          // }}
          >
            <InfoTwoToneIcon />
          </MuiButton>
        );
      },
      headerClassName: 'super-app-theme--header',
    },
  ];

  const columnsResponsive: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Identificador',
      editable: false,
      sortable: false,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'registrationDateTime',
      headerName: 'Data de criação',
      editable: false,
      sortable: false,
      flex: 2,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'situation',
      headerName: 'Situação',
      editable: false,
      sortable: false,
      flex: 1,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'actions',
      headerName: '',
      editable: false,
      sortable: false,
      flex: 1,
      renderCell: (params) => (
        <MuiButton
          variant='contained'
          size='small'
          onClick={() => handleInfo(params.id, params.row.situation)}
          sx={{
            minWidth: 0,
          }}
        >
          <InfoTwoToneIcon />
        </MuiButton>
      ),
      headerClassName: 'super-app-theme--header',
    },
  ];

  const handleInfo = (notificationId: GridRowId, situation: string) => {
    dispatch(
      fetchNotificationInfo({ notificationId: notificationId.toString() }),
    );
    dispatch(
      notificationSlice.actions.setNotificationInfoSituation({
        situation: situation,
      }),
    );
    dispatch(notificationSlice.actions.toggleNotificationInfoIsOpen());
  };

  return (
    <Table
      page={notificationsPage}
      changePage={(value: number) =>
        notificationsListSlice.actions.setNotificationsPage(value)
      }
      rows={rows}
      rowCount={notificationsTotalsSum}
      fetchRows={() =>
        dispatch(
          fetchNotificationsList({
            startDateTime: startDateTime,
            finalDateTime: finalDateTime,
            plate: plate,
            userName: userName,
            serviceOrderOrigin: serviceOrderOrigin,
            routeAreaId: routeAreaId,
            routeId: routeId,
            print: print,
            notificationId: notificationId,
            notificationUserId: notificationUserId,
            paymentOriginId: paymentOriginId,
            situationId: situationId,
          })
        )
      }
      columns={
        responsiveMode === 'phone' || responsiveMode === 'tablet'
          ? columnsResponsive
          : columns
      }
      toolbar={
        <NotificationsIssuedTableToolbar
          selectedRows={props.selectedRows}
          plate={plate}
        />
      }
      checkboxSelection
      disableSelectionOnClick
      isRowSelectable={(params: GridRowParams) =>
        params.row.situation === 'Irregular'
      }
      onSelectionModelChange={(selectionModel) => {
        props.setSelectedRows(selectionModel);
      }}
      loading={notificationsListLoading}
    />
  );
};